/* eslint-disable react/require-default-props, no-unused-vars */
import PropTypes from 'prop-types'
import { createTypeElement, createPropTypes } from './util'

const Header = ({ size = 'large', as = 'h1', fontType = 'page', ...props }) =>
  createTypeElement('Header', { size, as, fontType, ...props })
Header.propTypes = createPropTypes({
  size: PropTypes.oneOf(['large', 'medium', 'small']),
})

export default Header
